import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useCookieContext } from './cookie-context';
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, styled, Switch, Typography } from '@mui/material';
import './cookie-modal.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const CookiePreferencesModal = () => {
  const [t, i18next] = useTranslation("global");
  const { isPreferencesModalVisible, closePreferencesModal, setIsCookieIcon, setIsCookieActive } = useCookieContext();
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: true,
  });

  useEffect(() => {
    const savedPreferences = localStorage.getItem('cookiePreferences');
    if (savedPreferences) {
      setPreferences(JSON.parse(savedPreferences));
    } else {
      setPreferences({
        necessary: true,
        analytics: true,
      });
    }
  }, []);

  const savePreferences = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));

    if (preferences.analytics) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'analytics-consent', consent: 'granted' });
      ReactGA.gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'personalization_storage': 'granted',
        'functionality_storage': 'granted',
        'security_storage': 'granted'
      });
      setIsCookieActive(true);
    } else {
      window.dataLayer.push({ event: 'analytics-consent', consent: 'denied' });
      ReactGA.gtag('consent', 'update', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'personalization_storage': 'denied',
        'functionality_storage': 'denied',
        'security_storage': 'denied',
      });
      document.cookie = '_ga=; Max-age=0';
      document.cookie = '_gid=; Max-age=0';
      document.cookie = '_ga_4PCJRH6CQ9=; Max-age=0';
      document.cookie = '_ga_QDQ4G7WHMS=; Max-age=0';
      document.cookie = '_ga_Y67WW04KHJ=; Max-age=0';
      setIsCookieActive(false);
    }
    closePreferencesModal();
    setIsCookieIcon(true);
  };

  const handleTogglePreference = (key) => {
    setPreferences((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!isPreferencesModalVisible) return null;

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={isPreferencesModalVisible}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t('modals.cookies.preferences.title')}
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {t('modals.cookies.preferences.description1')}
        </Typography>
        <Typography gutterBottom>
          {t('modals.cookies.preferences.description2')}
        </Typography>
      </DialogContent>
      <DialogActions style={{ padding: '0 10%', marginTop: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <span>{t('modals.cookies.preferences.cookies1')}</span>
          <FormControlLabel
            control={
              <Switch
                defaultChecked
                disabled
                aria-label='Necessary cookies'
              />}
            label=""
            style={{ marginLeft: 'auto' }}
          />
        </div>
      </DialogActions>
      <DialogActions style={{ padding: '0 10%', marginTop: '20px', marginBottom: '30px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <span>{t('modals.cookies.preferences.cookies2')}</span>
          <FormControlLabel
            control={
              <Switch
                checked={preferences.analytics}
                onChange={() => handleTogglePreference('analytics')}
                aria-label='Analytics cookies'
              />}
            label=""
            style={{ marginLeft: 'auto' }}
          />
        </div>
      </DialogActions>
      <DialogActions>
        <Button
          onClick={savePreferences}
          variant='contained'
          color='primary'
          style={{
            backgroundColor: '#7220db',
            color: '#ffffff'
          }}
        >
          {t('modals.cookies.preferences.save')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default CookiePreferencesModal;
